export default __webpack_public_path__ + "static/media/soulfrost.08022b45.png";